import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Typography, Stack } from "@mui/material";

function Location() {
    const navigate = useNavigate();
    const location = useLocation();
    const [selected, setSelected] = useState("");

    useEffect(() => {
        // Only redirect if path is exactly /location (no country yet)
        if (location.pathname === "/location") {
            setSelected("india");
            navigate("/location/india", { replace: true });
        } else if (location.pathname.includes("india")) {
            setSelected("india");
        } else if (location.pathname.includes("malaysia")) {
            setSelected("malaysia");
        }
    }, [location, navigate]);

    const handleSelect = (country) => {
        setSelected(country);
        navigate(`/location/${country}`);
    };

    return (
        <Box sx={{ p: 6, textAlign: "center" }}>
            <Typography
                variant="h3"
                sx={{ color: "#030366", fontWeight: "bold", mb: 5, mt: 2 }}
            >
                Location
            </Typography>

            <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 4 }}>
                <Button
                    variant={selected === "india" ? "contained" : "outlined"}
                    color="primary"
                    onClick={() => handleSelect("india")}
                    sx={{ px: 4, py: 1.5, borderRadius: 3 }}
                >
                    India
                </Button>

                <Button
                    variant={selected === "malaysia" ? "contained" : "outlined"}
                    color="primary"
                    onClick={() => handleSelect("malaysia")}
                    sx={{ px: 4, py: 1.5, borderRadius: 3 }}
                >
                    Malaysia
                </Button>
            </Stack>

            <Outlet />
        </Box>
    );
}

export default Location;
